import api from '../../store/config/api';

export const [
  GET_FEATURES,
  GET_FEATURES_REQUEST,
  GET_FEATURES_SUCCESS,
  GET_FEATURES_FAILURE
] = api.buildTypes('GET_FEATURES');

export function getFeatures() {
  return {
    type: GET_FEATURES,
    payload: {
      url: `/features`,
      options: {
        method: 'GET'
      }
    }
  };
}



// WEBPACK FOOTER //
// ./js/actions/api/features.js